import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../../config/authAxios"



const initialState = { loading: false, data: [], error: "", message: "" }


export const getFAQAction = createAsyncThunk(
    'get-FAQ',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/support-knowladges/0/10/false`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getFAQSlice = createSlice({
    name: 'get-FAQ',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getFAQAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getFAQAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.message = action?.payload?.message
            })
            builder.addCase(getFAQAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.message = action?.payload?.message
            })
        },

})



export const getFAQReducer = getFAQSlice.reducer    